const TypesModal = {
      continuePedido: 1,
      adicionaItem: 2
}


export default TypesModal